
// Vue
import { Component, Mixins } from 'vue-mixin-decorator';
// Route
import { RouteConsts } from '@/routes/route';
// Consts
import { PageCategory } from '@/common/consts/index';
// Components
import BaseComponent from './BaseComponent.vue';

/**
 * ヘッダコンポーネント
 */
@Component({
  components: {}
})
export default class Header extends Mixins<BaseComponent>(BaseComponent) {
  private scrollY: number = 0;
  private confirmSignUpDialog: boolean = false;

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  }

  private handleScroll() {
    this.scrollY = window.scrollY;
  }

  get scrollDesign() {
    const top = {
      headerStyle: {
        'background-color': 'transparent !important',
        color: '#fff !important'
      },
      logo: require('@/assets/img/header/header_logo.png'),
      searchIcon: require('@/assets/img/header/header_icon_search.svg'),
      menuIcon: require('@/assets/img/header/account_on.png'),
      menuIconMobile: require('@/assets/img/header/dots-vertical_on.png'),
      btn: {
        color: '#fff !important',
        'font-weight': 'bold'
      }
    };

    const scrolled = {
      headerStyle: {},
      logo: require('@/assets/img/header/header_logo_on.png'),
      searchIcon: require('@/assets/img/header/header_icon_search_on.svg'),
      menuIcon: require('@/assets/img/header/account.png'),
      menuIconMobile: require('@/assets/img/header/dots-vertical.png'),
      btn: {
        'font-weight': 'bold'
      }
    };

    return this.scrollY == 0 && this.isHeaderDesignApply ? top : scrolled;
  }

  get pageCategory() {
    return this.store.getPageCategory;
  }

  get isHeaderDesignApply() {
    return this.store.getIsHeaderDesignApply;
  }

  get isBlogPage() {
    return this.store.getPageCategory === PageCategory.BLOG;
  }

  // お問い合わせ画面遷移
  private goToSupportPage() {
    this.$router.push({
      name: RouteConsts.SupportPage
    });
  }

  // コーポレートサイト遷移
  private goToCorporateSite() {
    window.open('https://www.monet-technologies.com/');
  }

  // トップページの検索ボックスへ遷移
  private goToSearchBox() {
    this.$router.push({
      name: RouteConsts.StoreTopPage,
      hash: '#searchBox'
    });
  }

  // チュートリアルページ画面遷移
  private goToTutorialsPage() {
    this.$router.push({
      name: RouteConsts.TutorialsPage
    });
  }
}
